@switch (state) {
  @case ('loading') {
    <div class="pvenda-pagina">
      <div class="pvenda-carregando" aria-busy="true">
        <mat-spinner diameter="48"></mat-spinner>
        <span>Carregando o documento…</span>
      </div>
    </div>
  }

  @case ('indisponivel') {
    <div class="pvenda-pagina">
      <div class="pvenda-estado">
        <app-empty-state icon="link_off" [title]="tituloIndisponivel" [subtitle]="mensagemIndisponivel"></app-empty-state>
      </div>
    </div>
  }

  @case ('view') {
    @if (resposta?.folha; as folha) {
      <div class="pvenda-pagina">
        <!-- Barra do documento: o seletor de layout (só o pedido tem três) e o "Gerar PDF", como na prévia do sistema. -->
        <div class="pvenda-barra">
          <div class="pvenda-barra-titulo">{{ tituloDocumento }}</div>
          <div class="pvenda-barra-acoes">
            @if (isPedido) {
              <button mat-stroked-button type="button" class="btn-filter" [matMenuTriggerFor]="menuLayout" aria-label="Layout do documento">
                layout {{ rotuloLayout(layout) }}
                <mat-icon iconPositionEnd class="material-symbols-outlined">arrow_drop_down</mat-icon>
              </button>
              <mat-menu #menuLayout="matMenu" class="pvenda-menu-layout">
                @for (opcao of layouts; track opcao) {
                  <button mat-menu-item type="button" [class.pvenda-layout-ativo]="opcao === layout" (click)="alterarLayout(opcao)">
                    layout {{ rotuloLayout(opcao) }}
                  </button>
                }
              </mat-menu>
            }
            <button mat-flat-button type="button" class="btn-primary" [disabled]="isImprimindo" (click)="imprimir()">
              <mat-icon class="material-symbols-outlined">picture_as_pdf</mat-icon>
              Gerar PDF
            </button>
          </div>
        </div>

        @if (resposta?.nomeEtapaFinal) {
          <app-alert-card type="warning" class="pvenda-aviso-etapa">
            Este documento está na situação <strong>{{ resposta?.nomeEtapaFinal }}</strong> e não está mais em andamento.
          </app-alert-card>
        }

        <app-venda-folha [dados]="folha" [layout]="layout"></app-venda-folha>
      </div>
    }
  }
}
